


























import { computed, defineComponent, ref, Ref } from '@nuxtjs/composition-api'
import CGoogleMap from '~/components/shared/configurable/map/CGoogleMap.vue'
import { formFieldProps } from '~/constants/form'
import { Geolocation } from '~/models/common/types'
import { useDeps } from '~/compositions/dependency-container'
import GoogleMapsService from '~/services/GoogleMapsService'
import { useClassifiedForm } from '~/compositions/form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'

export default defineComponent({
  components: { CFormError, CGoogleMap },
  props: formFieldProps,
  setup(props) {
    const selectedGeolocation = ref<Geolocation | null>(null)
    const selectedZoom = ref(5)

    const { getters } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)

    function onValue(v: Ref<any>) {
      if (v.value) {
        // we need this to zoom only when the geolocation has been altered by an external source
        // and not by moving the map marker manually
        const geolocationChangedExternally =
          v.value.lat !== selectedGeolocation.value?.lat ||
          v.value.lon !== selectedGeolocation.value?.lon

        if (geolocationChangedExternally) {
          selectedZoom.value = 15
        }

        selectedGeolocation.value = v.value
      }
    }

    const [googleMapsService] = useDeps(GoogleMapsService)
    const { valuesChanged, error } = useClassifiedForm(props, { onValue })

    async function handleMarkerChange(geolocation: Geolocation) {
      const {
        address,
        postcode
      } = await googleMapsService.getGeocodingProperties(geolocation)
      selectedGeolocation.value = geolocation

      valuesChanged([
        { name: 'address', value: address },
        { name: 'postcode', value: postcode },
        { name: 'geolocation', value: geolocation },
        { name: 'location', value: null }
      ])
    }

    function handleZoomChange(zoom: number) {
      selectedZoom.value = zoom
    }

    const isPlotForm = computed(() => getters('isPlotForm'))

    return {
      handleMarkerChange,
      selectedGeolocation,
      selectedZoom,
      handleZoomChange,
      error,
      isPlotForm
    }
  }
})
